<template>
  <div class="modal-backdrop" @click.self="$emit('cancel')" @keydown.esc="$emit('cancel')">
    <section class="modal-panel" role="dialog" aria-modal="true" :aria-labelledby="titleId">
      <header class="modal-header">
        <h2 :id="titleId" class="modal-title">{{ title }}</h2>
        <button type="button" class="icon-button modal-close" aria-label="Close" @click="$emit('cancel')">
          <X class="icon" />
        </button>
      </header>
      <div class="modal-body">
        <div class="modal-confirm" :class="{ danger }">
          <span class="modal-confirm-icon">
            <AlertTriangle v-if="danger" class="icon" />
            <HelpCircle v-else class="icon" />
          </span>
          <p class="modal-message">{{ message }}</p>
        </div>
      </div>
      <footer class="modal-footer">
        <button ref="cancelEl" type="button" class="btn btn-ghost" @click="$emit('cancel')">Cancel</button>
        <button type="button" :class="danger ? 'btn btn-danger' : 'btn btn-primary'" @click="$emit('confirm')">
          {{ confirmLabel }}
        </button>
      </footer>
    </section>
  </div>
</template>

<script setup lang="ts">
import { AlertTriangle, HelpCircle, X } from 'lucide-vue-next';
import { onMounted, ref, useId } from 'vue';

defineProps<{
  title: string;
  message: string;
  confirmLabel: string;
  danger?: boolean;
}>();

defineEmits<{
  confirm: [];
  cancel: [];
}>();

const titleId = useId();
const cancelEl = ref<HTMLButtonElement | null>(null);

onMounted(() => {
  cancelEl.value?.focus();
});
</script>
